/* ════ TOAST ═══════════════════════════════════════════════ */
import { $ } from '../dom.js';

let toastTimer;
export function showToast(msg) {
  const t = $('toast');
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove('show'), 2600);
}
